// extracted by mini-css-extract-plugin
export default {"button":"button_button__SmLwW","button--primary":"button_button--primary__zTvR8","button--danger":"button_button--danger__cfB4E","icon":"button_icon__4xw9A"};